import type { ComponentType, SVGProps } from 'react';
import InfoSvg from './svgs/Info.svg?react';
import ArrowLeftSvg from './svgs/ArrowLeft.svg?react';
import ArrowRightSvg from './svgs/ArrowRight.svg?react';
import CheckSvg from './svgs/Check.svg?react';
import CheckCircleSvg from './svgs/CheckCircle.svg?react';
import CheckboxSmallSvg from './svgs/CheckboxSmall.svg?react';
import CloseSvg from './svgs/Close.svg?react';
import MailSvg from './svgs/Mail.svg?react';
import PresentSvg from './svgs/Present.svg?react';
import SearchSvg from './svgs/Search.svg?react';
import WarningSvg from './svgs/Warning.svg?react';
import ShieldSvg from './svgs/Shield.svg?react';
import ChatBubbleSvg from './svgs/ChatBubble.svg?react';
import PhoneSvg from './svgs/Phone.svg?react';
import RadioSelectedSvg from './svgs/RadioSelected.svg?react';
import RadioUnselectedSvg from './svgs/RadioUnselected.svg?react';
import { colors } from '../../../../styles/colors';

type SvgIconComponent = ComponentType<SVGProps<SVGSVGElement> & { primary?: string; secondary?: string }>;

const svgComponents = {
  info: InfoSvg,
  arrowright: ArrowRightSvg,
  arrowleft: ArrowLeftSvg,
  chevronright: ArrowRightSvg,
  chevronleft: ArrowLeftSvg,
  check: CheckSvg,
  checkcircle: CheckCircleSvg,
  checkboxsmall: CheckboxSmallSvg,
  close: CloseSvg,
  mail: MailSvg,
  present: PresentSvg,
  search: SearchSvg,
  warning: WarningSvg,
  shield: ShieldSvg,
  chatbubble: ChatBubbleSvg,
  phone: PhoneSvg,
  radioselected: RadioSelectedSvg,
  radiounselected: RadioUnselectedSvg,
} as const;

export type SvgIconPreset = keyof typeof svgComponents;

export function isSvgIconPreset(value: string): value is SvgIconPreset {
  return Object.prototype.hasOwnProperty.call(svgComponents, value);
}

export function normalizeSvgIconPreset(raw: string): SvgIconPreset | undefined {
  const key = raw.trim().toLowerCase().replace(/-/g, '');
  return isSvgIconPreset(key) ? key : undefined;
}

export type SvgIconProps = {
  name: SvgIconPreset;
  size?: number;
  primaryColor?: string;
  secondaryColor?: string;
  className?: string;
  /** When true (default), hides the graphic from assistive technology (use when the button/link has its own name). */
  decorative?: boolean;
};

export function SvgIcon({
  name,
  size = 24,
  primaryColor = colors.dark,
  secondaryColor = colors.light,
  className,
  decorative = true,
}: SvgIconProps) {
  const Cmp = svgComponents[name] as SvgIconComponent;
  return (
    <span
      className={className}
      aria-hidden={decorative ? true : undefined}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
        width: size,
        height: size,
      }}
    >
      <Cmp primary={primaryColor} secondary={secondaryColor} width={size} height={size} />
    </span>
  );
}
